import { useCallback } from "react";

import type { ReservationDetailIssueReceiptInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationDetailIssueReceipt = (hotelID: string, reservationID: string) => {
	const { onReservationDetailIssueReceipt } =
		MutationRepository.useReservationDetailIssueReceiptMutation();

	/**
	 * 領収書の発行を実行
	 */
	const onIssueReceipt = useCallback(
		async (address?: string): Promise<{ pdfUrl: string } | undefined> => {
			const input: ReservationDetailIssueReceiptInput = {
				hotelID,
				reservationID,
				address: address || null,
			} satisfies ReservationDetailIssueReceiptInput;
			return onReservationDetailIssueReceipt(input);
		},
		[onReservationDetailIssueReceipt, hotelID, reservationID],
	);

	return {
		onIssueReceipt,
	};
};
